// web_components/wcVoucherConflictModal/wcVoucherConflictModal_Renderer.ts

/**
 * Generates the HTML for the wc-voucher-conflict-modal component.
 * Handles CSS, variables, etc.
 *
 * @param {object} dataAttributes - Data attributes for styling and contextual information.
 * @param {string} instanceId - A unique instance ID for generating unique element IDs.
 * @returns {string} - The HTML string for the content component.
 */
export function renderProductHTML(dataAttributes: any, instanceId: string): string {
	// Initialize styleTag to an empty string
	let styleTag = '';

	// Check if 'css' exists in dataAttributes and is an object
	if (dataAttributes.css && typeof dataAttributes.css === 'object') {
		styleTag = `<style>`;
		for (const [selector, styles] of Object.entries(dataAttributes.css)) {
			styleTag += `${selector} { ${styles} }`;
		}
		styleTag += `</style>`;
	}

	// Access variables and assign to 'variables', defaulting to an empty object if undefined
	const variables = dataAttributes.variables || {};

	return `
        ${styleTag}
        <div id="${instanceId}" class="wc-voucher-conflict-modal" role="dialog" aria-labelledby="voucherTitle" aria-describedby="voucherDescription" aria-modal="true" tabindex="-1">
        	<div class="wc-modal__overlay"><i></i></div>
			<div class="wc-modal__dialog">
				<div class="wc-voucher-conflict-modal__content">
					<h2 id="checkout-voucher-conflict-modal__title" class="wc-voucher-conflict-modal__title">Replace Voucher</h2>
					<h5 id="wc-voucher-conflict-modal__code">You already have a voucher on your account.</h5>
					<strong id="wc-voucher-conflict-modal__discount" hidden>${variables.voucherAmount}</strong>
					<p>Thanks for redeeming your voucher, however we have detected a ${variables.voucherAmount} voucher (code: ${variables.voucherCode}) on your account already, redeemed from a previous visit. You can continue with your new voucher or keep your ${variables.voucherAmount} voucher.</p>
					<button id="wc-voucher-conflict-modal__btn--replace" data-action="replace" class="wc-voucher-conflict-modal__btn" aria-label="Replace current voucher"><span>Continue with my new voucher</span></button>
					<a href id="wc-voucher-conflict-modal__cancel" data-action="cancel" data-dismiss="modal" aria-label="Close" tabindex="0">Keep the ${variables.voucherAmount} voucher</a>
				</div>
			</div>
        </div>
    `;
}
